var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrapper"},[_c('BasicModal',{attrs:{"title":_vm.title,"isShowModal":_vm.isShowModal,"canCancel":true},on:{"cancel":function($event){return _vm.cancel($event)}}},[_c('article',{staticClass:"container"},[_c('MessageDetail',{attrs:{"selectMessage":_vm.selectMessage},on:{"clickCloseBtn":_vm.clickCloseBtn}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4edee386","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/modals/ModalMessageDetail.vue
// module id = null
// module chunks = 